/* eslint-disable */
import hunca_mToken_core from "./hunca_mToken_core"

/********************************************
 *******************  请求  *****************
 *******************************************/
// 封装jsonp
const jsonp = (url, CallBack) => {
  return new Promise((resolve) => {
    // 动态创建script标签
    const script = document.createElement('script')
    script.src = url
    document.body.appendChild(script)
    // 获取数据
    window[CallBack] = (data) => {
      // console.log(data)
      resolve(data)
    }
    // 当script加载完后，它已经完成了请求数据的任务，将其移除页面.
    script.onload = () => {
      script.parentNode.removeChild(script)
    }
  })
}

// 与软件进行通讯
const ConnectServ = (cmddata, CallData, ErrMsg) => {
  const CallBack = `CallBack${new Date().getTime()}`
  // 拼接参数
  const waitcmdext = `${encodeURIComponent(cmddata).replace(/%20/g, '+')}&CallBack=${CallBack}&CallData=${CallData}&ErrMsg=${ErrMsg}`
  const url = 'http://127.0.0.1:13426/execcmd?cmdbody=CMDDATA:' + waitcmdext;
  // 请求
  return new Promise((resolve, reject) => {
    jsonp(url, CallBack).then(res => {
      resolve(res)
    })
  })
}

/********************************************
 *****************  内部方法  ***************
 *******************************************/
// 判断服务状态
const isServe = async () => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  // 获取当前版本号
  const {retcode} = await ConnectServ('536870922;|;', 'isServe', "服务错误")
  if (retcode) {
    if (retcode < 3140) {
      data.code = 1
      data.msg = '服务版本过低'
    } else {
      data.msg = '服务版本正常'
    }
  } else {
    data.code = 2
    data.msg = '未安装服务'
  }
  return data
}

// uKey登录
const login = async () => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  const {retcode, errmsg} = await ConnectServ(`45;|;3,uKey|;|2,1|;|2,65535|;|3,|;|3,`, 'login', '请安装驱动并插入CA锁')
  if (retcode === 0) {
    data.msg = "uKey登录成功"
  } else {
    data.code = 1
    data.msg = errmsg
  }
  return data
}
// 关闭当前文档  0-关闭文档，不保存当前修改；1-关闭文档，保存当前修改； 2-如果文档已经被修改，显示保存文档对话框，否则直接关闭；其他-关闭文档，保存当前修改
const close = async (num = 0) => {
  const data = {code: 0, msg: ""}
  const {retcode} = await ConnectServ(`44;|;2,${num}`, "close", "关闭失败")
  if (retcode === 1) {
    data.msg = "关闭成功"
  } else {
    data.code = 1
    data.msg = "关闭失败"
  }
  return data
}
// 加载Base64文件
const loadFileBase64 = async (Base64) => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  const {retcode, errmsg} = await ConnectServ(`94;|;3,${Base64}`, "loadFileBase64", "加载Base64文件失败")
  if (retcode !== 0) {
    data.code = 1
    data.msg = errmsg
  }
  return data
}
// 从服务器加载文件
const loadFileUrl = async (url) => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  const closeRes = await close()
  if (closeRes.code !== 0) {
    return closeRes
  }
  const {retcode, errmsg} = await ConnectServ(`22;|;3,${url}`, "MonitorServEventback", "从服务器加载文件失败")
  if (retcode !== 1) {
    data.code = 1
    data.msg = errmsg
  }
  return data
}
// 可以点×关闭
const canBeClosed = async () => {
  await ConnectServ('998;|;2,1', "", "")
  await ConnectServ('990;|;2,1|;|2,50|;|2,50', "manualStamping", "")
}

// 获取总页数
const getPageNum = async () => {
  const {retcode} = await ConnectServ("536870917;|;", "getPageNum", "获取页数失败");
  return retcode
}

// post请求
const post = async (url, body = {}, header = {}, isUploadFile = true) => {
  // 初始化http
  await ConnectServ('61;|;', "httpInit", "")
  // 设置载荷
  for (const [key, value] of Object.entries(body)) {
    await ConnectServ(`59;|;3,${key}|;|3,${value}`, "setBody", "")
  }
  if (isUploadFile) {
    await ConnectServ(`67;|;3,file`, "setBody", "")
  }
  // 设置请求头
  for (const [key, value] of Object.entries(header)) {
    await ConnectServ(`23;|;3,SET_CURRENT_COOKIE|;|3,${key}:${value}`, "setHeader", "")
  }
  // 设置utf-8编码
  await ConnectServ(`23;|;3,SET_UTF8_MODE|;|3,1`, "setCoding", "")
  // 发起请求
  const {retstr} = await ConnectServ(`62;|;3,${url}`, "setUrl", "")

  try {
    return JSON.parse(retstr)
  } catch (e) {
    // 返回结果中文出现乱码  用正则判断是否成功
    if (/code.{2}0/.test(retstr)) {
      return {
        code: 0,
        msg: "请求成功"
      }
    } else {
      return {
        code: 500,
        msg: "请求失败"
      }
    }
  }
}
/********************************************
 *****************  公共方法  ***************
 *******************************************/
// 初始化
const init = async () => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  // 判断服务状态
  const isServeRes = await isServe()
  if (isServeRes.code !== 0) {
    data.code = 1
    data.msg = isServeRes.msg
    return data
  }
  // uKey登录
  const loginRes = await login()
  if (loginRes.code !== 0) {
    data.code = 2
    data.msg = loginRes.msg
    return data
  }
  return data
}

// 加载Base64文件
const loadPDF = async (str, fileName, type = "base64") => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  let loadFileRes
  if (type === "base64") {
    loadFileRes = await loadFileBase64(str)
  } else {
    loadFileRes = await loadFileUrl(str)
  }

  if (loadFileRes.code === 0) {
    data.msg = "加载成功"
    data.data = loadFileRes.msg
    // const res = await getFileBase64(fileName)
    // if (res.code === 0) {
    //   data.data = res.data
    // }
  } else {
    data.code = 1
    data.msg = "加载失败"
  }
  return data
}

// 获取文件的Base64
const getFileBase64 = async (fileName) => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  const {retstr} = await ConnectServ('182;|;3,|;|2,3', "getFileBase64", "获取文件失败")

  const bstr = atob(retstr);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  const blob = new Blob([u8arr], {type: 'application/pdf;chartset=UTF-8'});
  const url = window.URL.createObjectURL(blob);
  const file = new File([u8arr], fileName, {type: 'application/pdf;chartset=UTF-8'});
  data.data = {base64: retstr, url, blob, file}
  return data
}

// 手动盖章
const manualStamping = async () => {
  // 可以点×关闭
  await canBeClosed()
  // 满屏显示最前面
  await ConnectServ('990;|;2,1|;|2,50|;|2,50', "manualStamping", "")
  // 设置操作状态
  await ConnectServ('6;|;2,2568', "manualStamping", "")
  // 置顶
  await ConnectServ('996;|;2,1', 1, "")
}
// 隐式手动盖章
const implicitManualStamping = async (page = 0, x = 0, y = 0) => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  console.log({page, x, y})
  const {retcode} = await ConnectServ(`96;|;2,0|;|3,${page},${x},0,${y},50,0|;|3,|;|3,AUTO_ADD_SEAL_FROM_PATH`, "automaticStamp", "")
  if (retcode === 1) {
    data.msg = "手动签章成功"
  } else {
    data.code = 1
    data.msg = "手动签章失败"
  }
  return data
}

// 自动盖章
const automaticStamp = async (x = 0, y = 0) => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  // 获取文档总页数
  const pageNum = await getPageNum()
  let pageStr = ''
  for (let page = 1; page <= pageNum; page++) {
    pageStr += page + ","
  }
  console.log({x, y})
  // 第一个参数代表从第几页开始，0代表第一页开始，
  // 第二个参数是X坐标  坐标取值范围（0-50000）
  // 第三个第四个参数为固定参数
  // 第五个参数是Y坐标 坐标取值范围（0-50000）
  const {retcode} = await ConnectServ(`96;|;2,0|;|3,0,${x},1,5,${y},${pageStr}|;|3,|;|3,AUTO_ADD_SEAL_FROM_PATH`, "automaticStamp", "")
  if (retcode === 1) {
    data.msg = "自动签章成功"
  } else {
    data.code = 1
    data.msg = "自动签章失败"
  }
  return data
}

/*********   NoteType  *************
 1       笔迹批注
 2       文字批注
 3       图片和印章及二维条码
 4       链接
 10      手写区域及编辑区域
 250     图片
 251     印章
 252     条码
 ***********************************/
// 获取节点个数
const getNoteNum = async (NoteType = 251) => {
  const {retcode: noteNum} = await ConnectServ(`105;|;2,${NoteType}`, NoteType, "获取节点个数错误")
  return {
    code: 0,
    data: noteNum,
    msg: "获取盖章个数成功"
  }
}
// 获取ukey sn号码
const getUkeyInfo = async () => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  const mToken = new hunca_mToken_core();
  const devList = mToken.Hunca_GetUserListGN(); //枚举Ukey，获取证书G项信息列表
  if (null == devList || devList.length === 0) {
    data.code = 1
    data.msg = mToken.Hunca_GetLastError()
    return data;
  }
  if (devList.length === 0) {
    data.code = 2
    data.msg = '请插入Ukey，点击“刷新”按钮'
    return data;
  }
  const userNameGN = devList[0];
  const userName = mToken.Hunca_userNameGNToUserName(userNameGN); //将证书G项信息转化为证书名称

  if (!mToken.Hunca_DealCertInfo(userName)) {
    data.code = 3
    data.msg = mToken.Hunca_GetLastError()
    return data;
  }
  data.data = {
    // 证书序号
    SN: mToken.Hunca_GetSignCertSn(),
    userNameGN,
    userName,
    // 证书信息
    certificateInfo: mToken.Hunca_GetSignCertSubject(),
    // 生效时间
    certificateEffectiveTime: mToken.Hunca_GetValidTime(),
    // 过期时间
    certificateExpiration: mToken.HUnca_GetNotBeforeTime(),
  }
  return data
}

// ca登录信息
const getCALoginInfo = async (randomStr, pin) => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  const mToken = new hunca_mToken_core();
  const devList = mToken.Hunca_GetUserListGN(); //枚举Ukey，获取证书G项信息列表
  console.log(devList);
  if (null == devList || devList.length === 0) {
    data.code = 1
    data.msg = mToken.Hunca_GetLastError()
    return data;
  }
  if (devList.length === 0) {
    data.code = 2
    data.msg = '请插入Ukey，点击“刷新”按钮'
    return data;
  }

  const userNameGN = devList[0];
  const userName = mToken.Hunca_userNameGNToUserName(userNameGN); //将证书G项信息转化为证书名称

  if (!mToken.Hunca_DealCertInfo(userName)) {
    data.code = 3
    data.msg = mToken.Hunca_GetLastError()
    return data;
  }

  // 验证 对数据进行签名，并返回签名是否成功
  if (!mToken.Hunca_PKCS1(randomStr, userName, pin)) {
    data.code = 3
    data.msg = mToken.Hunca_GetLastError()
    return data;
  }

  data.data = {
    // 证书SN
    key: mToken.Hunca_GetSignCertSn(),
    // 签名结果
    sign: mToken.Hunca_GetSignData(),
    // 签名证书
    secret: mToken.Hunca_GetSignCert()

  }
  return data
}


// 获取印章
const getSeal = async () => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  const {
    retcode,
    retstr
  } = await ConnectServ("120;|;3,GET_SEAL_PREDEFBMP|;|2,0|;|3,gif|;|2,0|;|3,", "getSeal", "获取印章失败")
  if (retcode !== 0) {
    data.code = 1
    data.msg = "获取印章失败"
  } else {
    data.data = retstr.split("@@@")[1]
    data.msg = "获取印章成功"
  }
  return data
}

// 上传文件
const uploadFile = async (url, body, header) => {
  const data = {
    code: 0,
    data: null,
    msg: ""
  }
  const res = await post(url, body, header)
  if (res.code !== 0) {
    data.code = 1
    data.msg = res.msg
  } else {
    data.data = res.data
    data.msg = res.msg
  }
  return data
}
export default {
  // 初始化
  init,
  // 加载Base64文件
  loadPDF,
  // 从服务器加载文件
  loadFileUrl,
  // 获取文件的Base64
  getFileBase64,
  // 手动盖章
  manualStamping,
  // 隐式手动盖章
  implicitManualStamping,
  // 自动盖章
  automaticStamp,
  // 获取节点个数
  getNoteNum,
  // 获取ukey sn号码
  getUkeyInfo,
  // 获取印章
  getSeal,
  // 上传文件
  uploadFile,
  // ca登录信息
  getCALoginInfo
}
